module.exports = __webpack_public_path__ + "static/media/pickup.a7dbd45a.svg";